import { useMutation, useQueryClient } from "@tanstack/react-query";
import { vacancyStatusTemplateService } from "@/services/vacancyStatusTemplateService";

export const useDeleteVacancyStatusTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (templateId) => vacancyStatusTemplateService.deleteTemplate(templateId),
    onSuccess: () => {
      queryClient.invalidateQueries(["vacancy-status-templates"]);
    },
  });
};

